<template>
    <div :id="'module-' + data.id" :style="moduleStyle">
        <root-module v-if="data.type == 'root'" :data="data">
            <slot></slot>
        </root-module>

        <text-module v-else-if="data.type == 'text'" :data="data" />
        <title-module v-else-if="data.type == 'title'" :data="data" />
        <image-module v-else-if="data.type == 'image'" :data="data" />
        <socials-module v-else-if="data.type == 'socials'" :data="data" />
        <form-module v-else-if="data.type == 'form'" :data="data" />
        <button-module v-else-if="data.type == 'button'" :data="data" />
        <video-module v-else-if="data.type == 'video'" :data="data" />
    </div>
</template>

<script>
import RootModule from "./modules/RootModule.vue";
import TextModule from "./modules/TextModule.vue";
import TitleModule from "./modules/TitleModule.vue";
import ImageModule from "./modules/ImageModule.vue";
import SocialsModule from "./modules/SocialsModule.vue";
import FormModule from "./modules/FormModule.vue";
import ButtonModule from "./modules/ButtonModule.vue";
import VideoModule from "./modules/VideoModule.vue";

export default {
    name: "Module",
    props: {
        data: Object,
    },
    components: {
        RootModule,
        TextModule,
        TitleModule,
        ImageModule,
        SocialsModule,
        FormModule,
        ButtonModule,
        VideoModule,
    },
    computed: {
        moduleStyle() {
            if (this.data.layout == undefined) return;

            let layout = this.data.layout;

            let backgroundColor =
                layout.color == "transparent" ? "#00000000" : layout.color;

            let paddingTop = layout.paddingTop == "" ? 0 : layout.paddingTop;
            let paddingRight =
                layout.paddingRight == "" ? 0 : layout.paddingRight;
            let paddingBottom =
                layout.paddingBottom == "" ? 0 : layout.paddingBottom;
            let paddingLeft = layout.paddingLeft == "" ? 0 : layout.paddingLeft;

            return {
                backgroundColor: backgroundColor,
                color: "#000000",
                paddingLeft: paddingLeft + "px",
                paddingRight: paddingRight + "px",
                paddingTop: paddingTop + "px",
                paddingBottom: paddingBottom + "px",
            };
        },
    },
};
</script>

<style></style>
